/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Modal,
  useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';

interface Props {
  src: string | undefined;
  isOpen: boolean;
  onClose: () => void;
  closeButton?: boolean;
  maxWidth?: React.CSSProperties['maxWidth'];
  maxHeight?: React.CSSProperties['maxHeight'];
  alt?: string;
}

const LOADER_SIZE = 32;

function ImageModal({
  src,
  isOpen,
  onClose,
  closeButton = true,
  maxWidth = '90vw',
  maxHeight = '80vh',
  alt,
}: Props) {
  const theme = useTheme();

  const [aspectRatio, setAspectRatio] = React.useState<number | undefined>();
  const [loadingEnlarged, setLoadingEnlarged] = React.useState(true);

  React.useEffect(() => {
    if (isOpen) {
      setLoadingEnlarged(true);
    }
  }, [isOpen]);

  return (
    <Modal open={isOpen} onClose={onClose} disableAutoFocus>
      <Fade in={isOpen} unmountOnExit>
        <Box
          sx={{
            flex: 1,
          }}>
          {closeButton && (
            <Button
              variant="link"
              sx={{
                position: 'fixed',
                top: 16,
                left: 16,
                p: 2,
                minWidth: 0,
              }}
              onClick={onClose}>
              <Close htmlColor={theme.palette.lightGrey.main} />
            </Button>
          )}
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'transparent',
              width: '100%',
              aspectRatio: aspectRatio ? `${aspectRatio}` : undefined,
              minWidth: LOADER_SIZE,
              minHeight: LOADER_SIZE,
              maxWidth,
              maxHeight,
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
            }}>
            {loadingEnlarged && (
              <Box
                flex={1}
                width="100%"
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                zIndex={1000}>
                <CircularProgress color="primary" size={LOADER_SIZE} />
              </Box>
            )}
            <img
              src={src}
              alt={alt || 'Image'}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                zIndex: 1001,
                overflow: 'hidden',
                pointerEvents: 'auto',
              }}
              onLoad={e => {
                const target = e.target as HTMLImageElement;
                setAspectRatio(target.width / target.height);
                setLoadingEnlarged(false);
              }}
            />
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ImageModal;
